import { Effect } from '../types';

/**
 * Compare two effects, assume all params are comparable primitives
 */
export function compareEffects(a: Effect, b: Effect) {
  if (a.name !== b.name) {
    return false;
  }

  if (!a.params && !b.params) {
    return true;
  }

  if (!a.params || !b.params) {
    return false;
  }

  const aKeys = Object.keys(a.params);
  const bKeys = Object.keys(b.params);

  if (aKeys.length !== bKeys.length) {
    return false;
  }

  return aKeys.every(
    (key) =>
      a.params![key as keyof typeof a.params] ===
      b.params![key as keyof typeof b.params],
  );
}
